import { Button, Grid, IconButton, Paper, TableBody, TableCell, Link as MuiLink, TableContainer, TableHead, TableRow, Typography, useTheme, CircularProgress, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@material-ui/core";
import { TechWriterDate } from "../reportWritersAgenda/TechWriterDate";
import { generalFilter, useDefaultColumn } from "../../../../util/filter";
import React, { useState } from "react";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import moment from "moment";
import { ReportApproversNotes } from "./ReportApproversNotes";
import { useReportApproverNotes } from "../../../common/CommonMutations";
import { useFilters, useGlobalFilter, useSortBy, useTable } from "react-table";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MuiTable from "@material-ui/core/Table";
import { toast } from "react-toastify";
import { useFetchContext } from "../../../common/FetchContext";
import { usemoveToDelivered, useMoveToWriter } from "../../../common/CommonQueries";
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { ApproverFileUpload } from "./ApproverFileUpload";
import { FileUploadApprover } from "./FileUploadApprover";
import GetAppIcon from '@material-ui/icons/GetApp';

import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import { ApproverCheckListView } from "./ApproverCheckListView";
import ScreenWidth from "../../../common/ScreenWidth";


export const ReportApproversTable = ({ data, refetch }: any) => {
    const defaultColumn = useDefaultColumn();
    const theme = useTheme();
    const widthCurrent = ScreenWidth();
    const { authAxios } = useFetchContext();
    const { mutateAsync: mutateMoveToDelivered, isLoading: loadingApprover } = usemoveToDelivered();
    const { mutateAsync: mutateMoveToWriter } = useMoveToWriter();

    const [reportDialogOpen, setReportDialogOpen] = useState(false);
    const [selectedReportData, setSelectedReportData] = useState<{ id: any } | null>(null);

    const handleOpenReportDialog = (id: any) => {
        setSelectedReportData({ id });
        setReportDialogOpen(true);
    };

    const handleCloseReportDialog = () => {
        setReportDialogOpen(false);
        setSelectedReportData(null);
    };





    const columns = React.useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filter: generalFilter,
            },
            {
                id: "Approver",
                accessor: "approver_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Report Type",
                accessor: "report_type",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
            },
            {
                id: "Report",
                accessor: "report_result_id",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => (
                    <MuiLink style={{ cursor: "pointer" }}>
                        {value}
                    </MuiLink>
                ),
            },
            {
                Header: "Customer",
                accessor: "customer_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Project",
                accessor: "project_number",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Report Version Number",
                accessor: "report_version_number",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "BOM Type",
                accessor: "bom",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "PM",
                accessor: "project_manager_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Author",
                accessor: "author_name",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "NTP",
                accessor: "ntp_date",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
            },
            {
                id: "Contractual Obligated",
                accessor: "contractually_obligated_date",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
            },
            {
                id: "Date Entered",
                accessor: "date_entered",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : "N/A"}</>
            },
            {
                id: "Status (PAN)",
                accessor: "status_pan",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>
            },
            {
                id: "Date Verified (PM)",
                accessor: "date_verified",
                filter: generalFilter,
                Cell: ({ row }: any) => {
                    const { id, date_verified, report_result_id, project_manager_name } = row.original;

                    return date_verified ? (
                        <span style={{ textAlign: "center", display: "block" }}>
                            {moment(date_verified).format("DD-MM-YYYY HH:mm:ss")}
                        </span>
                    ) : (
                        <TechWriterDate name={"date_verified_pm"} report_id={report_result_id} refetch={refetch} pmName={project_manager_name} />
                    );
                },
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
            },
            {
                id: "Date Approved(Approver)",
                accessor: "date_approved",
                filter: generalFilter,
                Cell: ({ row }: any) => {
                    const { id, date_approved, report_result_id, date_verified, approver_name } = row.original;


                    return date_approved ? (
                        <span style={{ textAlign: "center", display: "block" }}>
                            {moment(date_approved).format("YYYY-MM-DD HH:mm:ss")}
                        </span>
                    ) : (
                        <TechWriterDate name={"date_approved"} report_id={report_result_id} refetch={refetch} disabled={!date_verified} approver_name={approver_name} />
                    );
                },
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",

            },
            {
                id: "Date Delivered (PM)",
                accessor: "date_delivered",
                filter: generalFilter,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",

                Cell: ({ row }: any) => {
                    const { date_delivered, report_result_id, date_approved, project_manager_name } = row.original;

                    return !date_delivered ? (
                        <TechWriterDate name={"date_delivered"} report_id={report_result_id} refetch={refetch} disabled={!date_approved} pmName={project_manager_name} />
                    ) : (
                        <span style={{ textAlign: "center", display: "block" }}>
                            {moment(date_delivered).format("YYYY-MM-DD HH:mm:ss")}
                        </span>
                    );
                }
            },
            {
                id: "report",
                Header: "Report",
                disableFilters: true,
                width: 250,
                minWidth: 150,
                maxWidth: 300,
                align: "center",

                Cell: ({ row }: any) => {
                    const { report_result_id } = row.original;

                    return (
                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            <MuiLink
                                component="button"
                                variant="body1"
                                color="primary"
                                onClick={() => handleOpenReportDialog(report_result_id)}
                            >
                                View Report
                            </MuiLink>
                        </div>
                    );
                },
            },
            {
                id: "report_file",
                Header: "Final Report",
                filter: generalFilter,
                Cell: ({ row }: any) => {
                    const { report_result_id, work_order_id, report_file } = row.original;


                    return (
                        <FileUploadApprover report_id={report_result_id} work_order_id={work_order_id} refetch={refetch} />
                    );
                },
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
            },

            {
                id: "Check_List",
                Header: "Check List",
                disableFilters: true,
                width: 250,
                minWidth: 200,
                maxWidth: 300,
                align: "center",
                Cell: ({ row }: any) => {
                    const {report_result_id} = row.original
                    const [open, setOpen] = React.useState(false);
                    {console.log("approver",report_result_id)}


                    return (
                        <>
                            <IconButton
                                style={{
                                    color: "green",
                                }}
                                size="small"
                                onClick={() => {
                                    setOpen(true);
                                }}

                            >
                                <PlaylistAddCheckIcon fontSize="large" />
                            </IconButton>

                            {open && (
                                <ApproverCheckListView
                                    id={report_result_id}
                                    open={open}
                                    onClose={() => setOpen(false)}
                                />
                            )}


                        </>
                    );
                }
            },

            {
                id: "approve",
                Header: "Reviewed",
                disableFilters: true,
                width: 250,
                minWidth: 150,
                maxWidth: 300,
                align: "center",
                Cell: ({ row }: any) => {
                    const { report_result_id, date_delivered, is_approver } = row.original;
                    const [openApproveDialog, setOpenApproveDialog] = useState(false);
                    const [comment, setComment] = useState("");
                    const [loading, setLoading] = useState(false);

                    const handleCloseDialogs = () => {
                        setOpenApproveDialog(false);
                        setComment("");
                        setLoading(false);
                    };

                    const handleApprove = async () => {
                        if (!date_delivered) {
                            toast.warn("Date delivered is missing. Please assign the delivered date.");
                            return;
                        }
                        try {
                            setLoading(true);
                            await mutateMoveToDelivered({
                                report_result_id: report_result_id,
                                comments: comment,
                                authAxios,
                            });
                            toast.success("Report is moved to Delivered!");
                            await refetch();
                            handleCloseDialogs();
                        } catch (error) {

                            const message =
                                error?.response?.data?.error ||
                                error?.message ||
                                "Unexpected error occurred";
                            toast.error(message);
                            setLoading(false);
                        }

                    };



                    return (
                        <>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                <Tooltip title="Approve">
                                    <IconButton
                                        size="small"
                                        style={{ backgroundColor: 'green', color: 'white', padding: "4px", width: "25px", height: "25px" }}
                                        onClick={() => setOpenApproveDialog(true)}
                                    >
                                        <CheckIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>

                            {is_approver ? (
                                <Dialog open={openApproveDialog} onClose={handleCloseDialogs}>
                                    <DialogTitle>Approve Report</DialogTitle>
                                    <DialogContent>
                                        <Typography style={{ marginBottom: "20px" }}>
                                            Are you sure you want to approve this report?
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            label="Comments"
                                            variant="outlined"
                                            size="small"
                                            value={comment}
                                            onChange={(e) => setComment(e.target.value)}
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleCloseDialogs}>Cancel</Button>
                                        <Button
                                            onClick={handleApprove}
                                            style={{ backgroundColor: 'green', color: 'white' }}
                                            variant="contained"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <CircularProgress size={24} color="inherit" />
                                            ) : (
                                                "Approve"
                                            )}
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            ) : (
                                <Dialog open={openApproveDialog} onClose={handleCloseDialogs}>
                                    <DialogTitle>Access Denied</DialogTitle>
                                    <DialogContent>
                                        <Typography>
                                            You are not authorized to approve this report. Please contact an approver.
                                        </Typography>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleCloseDialogs} variant="contained" color="primary">
                                            Close
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            )
                            }



                        </>
                    );
                }
            },


            {
                id: "notes",
                Header: "Notes",
                disableFilters: true,
                width: 250,
                minWidth: 150,
                maxWidth: 300,
                align: "center",
                Cell: ({ row }: any) => {
                    const { approver_id, report_result_id, report } = row.original;

                    return <ReportApproversNotes
                        id={approver_id}
                        reportResultId={report_result_id}

                        type={1}
                        model={"report"}
                        invalidate={[
                            "my_reports",
                            ["projectNotes", row.values.id],
                            "report_Writer",
                        ]}
                        getNotes={useReportApproverNotes}

                    />;
                },
            },
        ],
        []
    );

    const { getTableProps, visibleColumns, headerGroups, rows, prepareRow } =
        useTable(
            {
                data: data,
                columns,
                defaultColumn,
                initialState: {
                    hiddenColumns: ["id"],

                },
            },
            useFilters,
            useGlobalFilter,
            useSortBy,

        );

    return (
        <>
            <TableContainer
                data-testid="tableContainer"

                style={{
                    ...theme.tableContainer,
                    maxHeight: "500px",
                    overflowX: 'auto',
                    overflowY: 'auto',
                    whiteSpace: 'nowrap',
                    maxWidth: `${widthCurrent}px`
                }}
                component={Paper}
            >
                <MuiTable stickyHeader {...getTableProps()} size="small">
                    <TableHead>
                        {headerGroups.map((headerGroup) => (
                            <TableRow {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <TableCell
                                        style={{
                                            // ...theme.noLeftRightPadding,
                                            width: column.width,
                                            minWidth: column.minWidth,
                                            maxWidth: column.maxWidth,
                                            textAlign: 'center',

                                        }}
                                    >

                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="center"
                                            spacing={0}
                                        >
                                            <Grid item xs={12} {...column.getHeaderProps()}>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={0}
                                                >
                                                    <Typography variant="subtitle2">
                                                        {(
                                                            column.id === "notes" ||
                                                            column.id === "approve" ||
                                                            column.id === "report_file" ||
                                                            column.id === "Check_List" ||
                                                            column.id === "report") &&
                                                            column.render("Header")}
                                                    </Typography>
                                                    {column.canFilter ? column.render("Filter") : null}
                                                    {/* <Typography variant="subtitle2">
                                                    {column.render("Header")}
                                                </Typography>

                                                {!(column.id === "notes" || column.id === "add_tasks") && column.canFilter && column.render("Filter")} */}

                                                    <Grid item xs={2}>
                                                        <IconButton
                                                            type="submit"
                                                            aria-label="search"
                                                            size="small"
                                                            {...column.getSortByToggleProps()}
                                                        >
                                                            {column.isSorted ? (
                                                                column.isSortedDesc ? (
                                                                    <ArrowDropDownIcon />
                                                                ) : (
                                                                    <ArrowDropUpIcon />
                                                                )
                                                            ) : (

                                                                column.id !== "notes" &&
                                                                column.id !== "approve" &&
                                                                column.id !== "report_file" &&
                                                                column.id !== "Check_List" &&
                                                                column.id !== "report" &&

                                                                <CallSplitIcon />
                                                            )}
                                                        </IconButton>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            prepareRow(row);
                            return (
                                <>
                                    <TableRow {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            return (
                                                <TableCell {...cell.getCellProps()}
                                                    style={{
                                                        width: cell.column.width,
                                                        minWidth: cell.column.minWidth,
                                                        maxWidth: cell.column.maxWidth,
                                                        // textAlign: 'center',
                                                    }}
                                                >
                                                    {cell.render("Cell")}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>


                                </>
                            );
                        })}
                    </TableBody>
                </MuiTable>
            </TableContainer>
            <Dialog open={reportDialogOpen} onClose={handleCloseReportDialog} maxWidth="md" fullWidth>
                <DialogTitle>Report Template</DialogTitle>
                <DialogContent>
                    {selectedReportData && (
                        <ApproverFileUpload key={selectedReportData.id} id={selectedReportData.id} />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseReportDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

        </>

    )
}